import {httpPost} from './base'
// tab1 运营详情数据
export const loadPackagesOrders = (params) => { return httpPost('operateDetails/packagesOrders', params).then(res => res) }



// WEBPACK FOOTER //
// ./src/api/operate-details.js